export default {
    namespaced: true,

    state: {
        insightTraits: null,
        user: JSON.parse(localStorage.getItem("user-info")) || "",
        token: localStorage.getItem("user-token") || "",
        personality: null,
        groups: null,
        comparison: null,
        cycle: null,
    },

    mutations: {
        setInsightTraits(state, insightTraits) {
            state.insightTraits = insightTraits;
        },
        setUser(state, user) {
            state.user = user;
        },
        setToken(state, token) {
            state.token = token;
        },
        setPersonality(state, personality) {
            state.personality = personality;
        },
        setGroups(state, groups) {
            state.groups = groups;
        },
        setComparison(state, comparison) {
            state.comparison = comparison;
        },
        setCycle(state, cycle) {
            state.cycle = cycle;
        }
    },

    getters: {
        getInsightTraits: ((state) => {
            return state.insightTraits;
        }),
        getUser: ((state) => {
            return state.user;
        }),
        getToken: ((state) => {
            return state.token;
        }),
        getPersonality: ((state) => {
            return state.personality;
        }),
        getGroups: ((state) => {
            return state.groups;
        }),
        getComparison: ((state) => {
            return state.comparison;
        }),
        getCycle: ((state) => {
            return state.cycle;
        }),
    }
};